import { Component, SimpleChanges, ViewChild } from "@angular/core";
import { AdminMenusService } from "../admin-sidebar/admin-menus.service";
import {
  initialSharedModel,
  SharedModel,
} from "../shared/sharedmodel/shared.model";
import { MatDialog } from "@angular/material/dialog";
import { AddEditMasterComponent } from "./components/add-edit-master/add-edit-master.component";
import { AddEditMasterValueComponent } from "./components/add-edit-master-value/add-edit-master-value.component";
import { MasterListComponent } from "./components/master-list/master-list.component";
import { ApiserviceService } from "../../../../src/app/apiservice.service";
import { CommonfunctionService } from "../../../../src/app/services/commonfunction.service";
import { NotificationService } from "../services/notification.service";
import { CopyMasterValuesComponent } from "./components/copy-master-values/copy-master-values.component";
import { FormControl } from "@angular/forms";
import { debounceTime } from "rxjs";

@Component({
  selector: "app-admin-gis-masters",
  templateUrl: "./admin-gis-masters.component.html",
  styleUrls: ["./admin-gis-masters.component.scss"],
})
export class AdminGisMastersComponent {
  @ViewChild(MasterListComponent) masterListComponent!: MasterListComponent;
  isLoading: boolean = false;
  displayColumn = ["checkbox","id","master_value_name", "master_value_label","active_status","action"];
  totalCount = 0;
  sharedModel: SharedModel = { ...initialSharedModel }; // use common variable from share model file
  masterValueData: any;
  masterValueOptions: any;
  selectedMasterid: any;
    status_list = [
    { value: 'null', viewValue: "All" },
     { value: "1", viewValue: "Active" },
    { value: "0", viewValue: "Inactive" }
  ];
  selectedStatus = this.status_list[0].value;
  masters_access = {
    GET: false, // Permission for GET requests
    POST: false, // Permission for POST requests
    PATCH: false, // Permission for PATCH requests
    DELETE: false, // Permission for DELETE requests
  };
      // Configuration object for button actions and styles
    buttonConfig = {
      action: [
        {
          // label:'edit',
          action: (element:any) => this.createMasterValue(element, 'edit'), // Function to update master value
          icon: "assets/icon/edit-icon.svg",
          style: {
            backgroundColor: "#fff",
            marginRight:"20px"
          },
          class: "action-button",
          isActionColumnClass:'btnIconClass'
        }
      ],
    };
  selectedMasterName: any;
  masterDataList: any[];
  selectedRows: any;
  searchField: FormControl;
  sortField: string;
  sortOrder: string;
  status: any = 'null';
  constructor(
    private menus: AdminMenusService,
    public dialog: MatDialog,
    private api: ApiserviceService,
    private fnc: CommonfunctionService, // Injecting common function service
    private notify: NotificationService, // Injecting notification service for user notification
  ) {
    this.menus.setActive("masters");
  }
  ngOnChanges(changes: SimpleChanges): void {
   const mastersData = this.masterListComponent?.selectedMaster || [];
    this.selectedMasterid = mastersData.id
    this.selectedMasterName = mastersData;
    this.masterDataList = this.masterListComponent?.masters || [];
  }
  ngOnInit(): void {
    // this.masterDataList = this.masterListComponent?.masters || [];
    // console.log(this.masterDataList, "this.masterDataList");
     this.getAllowResourcesApi()
        this.searchField = new FormControl();
    this.searchField.valueChanges
    .pipe(debounceTime(500))
      .subscribe(term => {
        term = term.trim().toLowerCase();
        if (term) {
          this.fetchMasterValueData(term);
        } else {
          this.fetchMasterValueData(null);
        }
      })
  }
    onSelectedRowsChange(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    // Handle selected rows (e.g., perform batch actions)
  }
   getAllowResourcesApi() {
    this.api.getUserRole();
    let body = `user/resource?place_id=${this.api.city_id}&user_id=${this.api.user_id}`;
    this.api.getUmsData(body).subscribe((res: any) => {
      this.api.allowResources = res.data;
      this.getAllowResource();
    });
  }

   getAllowResource() {
    this.masters_access =
      this.fnc.checkResourceAccess("masters");
  }

  onPageChange(event: any) {
    this.sharedModel.limit = event.limit; // Update limit based on pagination event
    this.sharedModel.offset = event.offset; // Update offset based on pagination event
  }
 createMaster(event: any = null, type: string = "add") {
   // 🟢 Step 1: Access control check
  if (type === "add" && !this.masters_access.POST) {
    this.notify.notify(
      "Access declined: You are not authorized to create new masters.",
      "warn"
    );
    return;
  }

  if (type === "edit" && !this.masters_access.PATCH) {
    this.notify.notify(
      "Access declined: You are not authorized to update masters.",
      "warn"
    );
    return;
  }
  const mastersData = this.masterListComponent?.masters || [];

  // Prepare dialog data
  const dialogData: any = {
    parent: this,
    MasterData: mastersData,
    type, // 'add' or 'edit'
  };

  // If edit, pass the selected master
  if (type === "edit" && event) {
    dialogData.selectedValue = event;
  }

  const dialogRef = this.dialog.open(AddEditMasterComponent, {
    width: "600px",
    panelClass: "create-master-panel",
    data: dialogData,
  });

  dialogRef.afterClosed().subscribe((result) => {
    if (result) {
      this.masterListComponent.fetchMasterData();
    }
  });
}


  onMasterSelected(selectedMaster: any) {
  this.selectedMasterid = selectedMaster.id;
  this.selectedMasterName = selectedMaster.label[this.api.language];
   this.fetchMasterValueData();
}

createMasterValue(event: any = null, type: string = "add") {
    // 🟢 Step 1: Access control check
  if (type === "add" && !this.masters_access.POST) {
    this.notify.notify(
      "Access declined: You are not authorized to create new master Value.",
      "warn"
    );
    return;
  }

  if (type === "edit" && !this.masters_access.PATCH) {
    this.notify.notify(
      "Access declined: You are not authorized to update master Value.",
      "warn"
    );
    return;
  }
  const mastersData = this.masterListComponent?.masters || [];

  // prepare data for dialog based on add/edit
  const dialogData: any = {
    parent: this,
    MasterData: mastersData,
    type, // pass type so dialog knows it's edit
  };

  if (type === "edit" && event) {
    dialogData.selectedValue = event; // send selected row/item to edit
  }

  const dialogRef = this.dialog.open(AddEditMasterValueComponent, {
    width: "600px",
    panelClass: "create-master-panel",
    data: dialogData,
  });

  dialogRef.afterClosed().subscribe((result) => {
    if (result) {
      this.fetchMasterValueData();
    }
  });
}


  fetchMasterValueData(searchterm = null) {
    this.isLoading = true;
    let url = `master-values?master_id=${this.selectedMasterid}&status=${this.status}`;
      if(this.sortField && this.sortOrder){
      url += `&sort_order=${this.sortOrder}&sort_by=${this.sortField}`;
    }
      if (searchterm != null) {
      url += `&search_text=${searchterm}`
    }
    this.api.getGmsData(url).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.masterValueData = res.data;
        // if (this.masterValueData.length > 0) {
          const currentLangId = this.api.language; // example: 1 or 2
          this.masterValueOptions = this.masterValueData.map((item: any) => ({
            ...item, // keep all original keys
            master_value_name: item.mv_name,
            master_value_label: item.mv_label?.[currentLangId] || item.mv_name,
          }));
        // }
      },
      error: (err) => {
        this.isLoading = false;
        console.error("Error creating master", err);
      },
    });
  }

  editMaster($event){
    this.createMaster($event, 'edit');
  }
  getMasterDataList(event){
    this.masterDataList = event;
    console.log(this.masterDataList, "this.masterDataList, this.masterDataList");

  }
      copyMasterValues(){
      if(!this.masters_access.POST){
        this.notify.notify("You are not authorized to copy master values","warn");
        return
        }
       // Check if any selected row has status = 0
const hasInactive = this.selectedRows.some((row) => row.status === 0);

if (hasInactive) {
  this.notify.notify(
    "Copy action is not allowed because one or more selected values are inactive.",
    "warn"
  );
  return;
}

      const dialogRef = this.dialog.open(CopyMasterValuesComponent, {
        width: '450px',
        data: this.selectedRows,
        disableClose:true
      });
      dialogRef.afterClosed().subscribe(result => {
        if(result){
          this.fetchMasterValueData();
          this.selectedRows = null
        }else{
          this.fetchMasterValueData();
        }
      });
    }
     onSort(event: { field: string, order: string }) {
    this.sortField = event.field;
    this.sortOrder = event.order;
   this.fetchMasterValueData();
  }

  resetSorting() {
    this.sortField = '';
    this.sortOrder = '';
    this.fetchMasterValueData();
  }
  updateMasterValueStatus(event: { logType: string; status: number; source?: any }){
   const url = "master-values";
    console.log(event?.logType);

  const element:any = event?.logType;

const payload = {
  master_value_name: element.master_value_name ?? element.mv_name,
  master_value_id: element.id,
  master_value_label: element.mv_label || { 1: element.master_value_label },
  status: event.status ,
  added_by: this.api.user_id,
  master_id: element.master_id,
  image_url: ''
};
    this.isLoading = true;
    this.api.patchGmsData(url, payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.fetchMasterValueData();
      },
      error: (err) => {
        this.isLoading = false
        console.error('Error creating master', err);
      }
    });
  }
  selectedUpdateStatus(event){
    this.status = event;
    this.fetchMasterValueData();

  }
}
